export default __webpack_public_path__ + "static/mirage-9ddcc8912c616a550c5cff3c848ad3b0.png";